export default __webpack_public_path__ + "static/media/p9_publisher2.48bbea16.png";